import { useApi } from './useApi';
import { url } from '../../utils/confserveur';

export const useEquipesQCM = (sessionId, refresh) => {
  const enabled = sessionId ? undefined : 'not-enabled';
  return useApi(`${url}equipes-qcm/?session=${sessionId}`, [], refresh, enabled);
};
